export default __webpack_public_path__ + "static/media/arlington_doors.1bd61e2c.jpg";